export default "__VITE_ASSET__Cn7d$mAI__"